module.exports = __webpack_public_path__ + "static/media/eye.77c3b612.gif";